import React from 'react'
import { Box, Typography } from '@mui/material'
import { advancedColors } from '../../theme'
import { MONTH_LABELS, TOTAL_WEEKS, WEEKS_PER_MONTH } from './categories'
import { cellInputSx, headerCellSx } from './gridSx'
import { LABEL_COL_PX, LABEL_COL_SHARE, WEEK_COL_PX } from './livePlan'

type Props = {
  weekZoom: boolean
  currentMonth: number | null
}

const PlanGridHead = ({ weekZoom, currentMonth }: Props) => (
  <>
    <Box component="colgroup">
      <Box component="col" sx={{ width: weekZoom ? LABEL_COL_PX : `${LABEL_COL_SHARE * 100}%` }} />
      {Array.from({ length: TOTAL_WEEKS }, (_, week) => (
        // eslint-disable-next-line react/no-array-index-key -- fixed week columns, never reordered
        <Box
          component="col"
          key={week}
          sx={{ width: weekZoom ? WEEK_COL_PX : `${((1 - LABEL_COL_SHARE) / TOTAL_WEEKS) * 100}%` }}
        />
      ))}
    </Box>
    <Box component="thead">
      <Box component="tr">
        <Box component="th" sx={headerCellSx} />
        {MONTH_LABELS.map((label, index) => (
          <Box
            component="th"
            key={label}
            colSpan={WEEKS_PER_MONTH}
            sx={{
              ...headerCellSx,
              ...cellInputSx,
              textAlign: 'left',
              ...(index === currentMonth ? { backgroundColor: advancedColors.greenSoft } : null),
            }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: advancedColors.ink }}>
              {label}
              {index === currentMonth && (
                <Typography component="span" variant="caption" sx={{ ml: 0.75, color: advancedColors.green }}>
                  Now
                </Typography>
              )}
            </Typography>
          </Box>
        ))}
      </Box>
      {weekZoom && (
        <Box component="tr">
          <Box component="th" sx={headerCellSx} />
          {Array.from({ length: TOTAL_WEEKS }, (_, week) => (
            // eslint-disable-next-line react/no-array-index-key -- fixed week columns, never reordered
            <Box component="th" key={week} sx={{ ...headerCellSx, ...cellInputSx, textAlign: 'center' }}>
              <Typography variant="caption" sx={{ fontWeight: 600, color: advancedColors.inkMuted }}>
                {`W${(week % WEEKS_PER_MONTH) + 1}`}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  </>
)

export default PlanGridHead
